import { Component, OnInit } from '@angular/core';
import { MatDialog, MatTableDataSource } from '@angular/material';
import { FolderService } from '../../../services';
import { Folder, InfoView } from '../../../models';
import { AngularFireAuth } from '@angular/fire/auth';
import { AddFolderDialog, EditFolderDialog } from '../../dialogs';

@Component({
  selector: 'folders-editor',
  templateUrl: './folders-editor.component.html',
  styleUrls: ['./folders-editor.component.css']
})
export class FoldersEditorComponent implements OnInit {
  folders: Folder[];
  selectedFolder: Folder;
  userId: string;
  loggedIn = false;
  opened = true;

  constructor(
    private folderService: FolderService,
    public dialog: MatDialog,
    private authService: AngularFireAuth
  ) {}

  ngOnInit() {
    this.authService.authState.subscribe(user => {
      if (user) {
        this.userId = user.uid;
        this.folderService.getForOwnerUser(this.userId).subscribe(folders => {
          console.info('[FoldersEditor] folders retrieved', folders);
          this.folders = folders;
          if (folders && folders.length > 0) {
            this.selectedFolder = folders[0];
          }
        });
      }
    });
  }

  newFolder(): void {
    const dialogRef = this.dialog.open(AddFolderDialog);
  }

  onSelectFolder(folder: Folder): void {
    console.info('[FoldersEditor] selected folder', folder);
    this.selectedFolder = folder;
  }

  deleteFolder(folder: Folder): void {
    const response = confirm('Are you sure you want to delete this Folder?');

    if (response) {
      console.info('deleting', folder);
      this.folderService.delete(folder.id);
      this.selectedFolder = undefined;
      console.info('deleted', folder);
    }
  }

  editFolder(folder: Folder): void {
    const dialogRef = this.dialog.open(EditFolderDialog, {
      data: folder,
      width: '400px',
      height: '380px'
    });

    dialogRef.afterClosed().subscribe((f: Folder) => {
      this.selectedFolder = f;
    });
  }

  addMember(folder: Folder): void {
    alert('Not implemented');
    // let dialogRef = this.dialog.open(AddGroupDialog, {
    //   data: group
    // });

    // dialogRef.afterClosed().subscribe((group: Group) => {
    //   if (group !== undefined) {
    //     this.selectedGroup = group;
    //   }
    // });
  }

  deleteMember(member: InfoView): void {
    alert('Not implemented.');
    // const response = confirm("Are you sure you want to delete this member?");
    // if (response) {
    //   const newMembers = this.selectedGroup.members.filter(b => b.id !== member.id);
    //   this.selectedGroup.members = newMembers;

    //   this.groupService.update(this.selectedGroup);
    // }
  }

  onMatchSelected(infoView: InfoView) {
    alert('Not implemented');
  }
}
